import cn from 'classnames'
import { FC, useCallback, useEffect } from 'react'

import { Checkbox } from 'core-components/library/checkbox'
import { AbsolutePopup, PopPaper, TPopupVertical } from 'core-components/library/popup'

import { usePopup } from '../../hooks/usePopup'

import { IOptionsButtonProps } from './models/optionsButtonProps'

import styles from './OptionsButton.module.scss'

export const OptionsButton: FC<IOptionsButtonProps> = ({
  listRef,
  showOnlySelected,
  onShowOnlySelectedChange,
}) => {
  const { isOpened, setOpened, togglePopup } = usePopup()

  const closePopupOnListScroll = useCallback(() => {
    if (isOpened) {
      setOpened(false)
    }
  }, [isOpened, setOpened])

  useEffect(() => {
    if (!listRef?.current) {
      return
    }

    if (isOpened) {
      listRef.current.addEventListener('scroll', closePopupOnListScroll)
    } else {
      listRef.current.removeEventListener('scroll', closePopupOnListScroll)
    }
  }, [listRef, isOpened, closePopupOnListScroll])

  return (
    <AbsolutePopup
      verticalStartPosition={TPopupVertical.Bottom}
      visibilityCallback={() => {
        return isOpened
      }}
      popupContent={() => (
        <PopPaper className={styles.options}>
          <Checkbox
            checked={showOnlySelected}
            onChange={onShowOnlySelectedChange}
            label="only selected"
          />
        </PopPaper>
      )}
    >
      <div
        className={cn(styles.optionsButton, {
          [styles.filterActive]: showOnlySelected,
        })}
        onClick={togglePopup}
      >
        <i className="kbase kbase-settings-alt" />
      </div>
    </AbsolutePopup>
  )
}
